import { connect } from 'react-redux'
import { arrayOf, func, number, oneOf, shape, string } from 'prop-types'
import React from 'react'
import { retainState } from '../../actions/app'
import {
  buildHeaderClassName,
  buildMainClassName,
  determineSelectedView,
  transformVenuesIntoRowsOfTiles,
} from '../../selectors'
import Filters from './Filters'
import ListView from '../ListView'
import MapView from './MapView'
import NumberOfResults from './NumberOfResults'
import TilesView from '../TilesView'
import RefineLink from './RefineLink'
import SortSelect from './SortSelect'
import ViewLink from './ViewLink'

const App = props => (
  <div className="app">
    <div className={props.headerClassName}>
      <div className="inner">
        <div className="left">
          <RefineLink />
        </div>
        <div className="middle">
          <ViewLink view="Tiles" />
          <ViewLink view="List" />
          <ViewLink view="Map" />
        </div>
        <div className="right">
          <NumberOfResults />
          <SortSelect />
        </div>
      </div>
    </div>
    <div className={props.mainClassName}>
      <Filters />
      {props.selectedView === 'tiles' &&
        <TilesView
          onClick={props.retainState}
          rowsOfTiles={props.rowsOfTiles}
          useWindowScroller
          venues={props.venues}
        />
      }
      {props.selectedView === 'list' &&
        <ListView
          listItems={props.listItems}
          onClick={props.retainState}
          useWindowScroller
        />
      }
      {props.selectedView === 'map' &&
        <MapView />
      }
    </div>
  </div>
)
App.propTypes = {
  headerClassName: string.isRequired,
  listItems: arrayOf(shape({
    city: string,
    country: string,
    hall_uses: arrayOf(string),
    image: string,
    name: string.isRequired,
    seat_count: number,
    site_building: string.isRequired,
    state_province_abbreviation: string,
    url: string.isRequired,
    year_built: number,
    year_renovated: arrayOf(number),
  })).isRequired,
  mainClassName: string.isRequired,
  retainState: func.isRequired,
  selectedView: oneOf(['tiles', 'list', 'map']).isRequired,
  venues: arrayOf(shape({})).isRequired,
}

const mapStateToProps = state => ({
  headerClassName: buildHeaderClassName(state),
  mainClassName: buildMainClassName(state),
  listItems: state.venue.venues,
  rowsOfTiles: transformVenuesIntoRowsOfTiles(state),
  selectedView: determineSelectedView(state),
  venues: state.venue.venues,
})

export default connect(mapStateToProps, {
  retainState,
})(App)
